import { IDataOptions } from '../core/common';
import {
  GetProfileResponseDto,
  IntercomDataDto,
  UpdateUserBodyDto,
  UserDto,
} from '../core/users';
import { HttpClient } from './http';
import { catch404ReturnNull, createQueryParams } from './util';

export interface ProfileService {
  syncProfile: () => Promise<void>;
  updateProfile: (params: UpdateUserBodyDto) => Promise<UserDto>;
  getProfile: (params?: IDataOptions) => Promise<GetProfileResponseDto | null>;
  getIntercomData: () => Promise<IntercomDataDto | null>;
  createBookingUser: () => Promise<void>;
}

export function createProfileService(
  httpClient: HttpClient,
  baseUrl: string,
): ProfileService {
  return {
    syncProfile: () => {
      return httpClient<void>(`${baseUrl}/profile/sync`, 'post');
    },

    updateProfile: (params: UpdateUserBodyDto) => {
      return httpClient<UserDto>(`${baseUrl}/profile`, 'patch', {
        body: params,
      });
    },

    getProfile: (params?: IDataOptions) => {
      const queryParams = createQueryParams(params as Record<string, unknown>);
      return catch404ReturnNull(() =>
        httpClient<GetProfileResponseDto>(
          `${baseUrl}/profile${queryParams}`,
          'get',
        ),
      );
    },

    getIntercomData: () => {
      return catch404ReturnNull(() =>
        httpClient<IntercomDataDto>(`${baseUrl}/profile/intercom-data`, 'get'),
      );
    },

    createBookingUser: () => {
      return httpClient<void>(`${baseUrl}/profile/create-booking-user`, 'post');
    },
  };
}
